<script lang="ts" setup>
// @ts-ignore
import { SplideSlide } from '@splidejs/vue-splide'
import './WidgetArticlesMostRead.scss'

export interface MostReadProps {
    data: BlogPost[]
    headingLevel: HeadingLevel
}

const props = defineProps<MostReadProps>()
const route = useRoute()
const { $t } = useNuxtApp()

const title = $t('Najčítanejšie články')
</script>

<template>
  <Box
    decor-position="top-left"
    color="black"
    class="rounded pt-12 overflow-hidden widget-articles-most-read"
    data-cy="widget_articles_most_read"
  >
    <Tracker :data="{ position: title }">
      <BoxHeader
        :heading="title"
        :heading-level="props.headingLevel"
        heading-color="text-white"
      />
      <Slider>
        <SplideSlide
          v-for="(article, index) in props.data"
          :key="`wai-${index}`"
          :has-track="false"
        >
          <ArticleBox
            :data="article"
            :link-type="
              useBlogPostLinkType(String(route.params.id))
            "
            :type="'secondary'"
            :color="'white'"
            :link-wrap="true"
          />
        </SplideSlide>
      </Slider>
    </Tracker>
  </Box>
</template>
